import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon } from 'antd';

import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
  TemplatePageOverview,
  TemplateImage,
} from './styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import Loader from '../../components/Loader';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import CreateMailTemplateModal from '../../components/CreateNewTemplate/CreateMailTemplateModal';
import { getTemplate } from '../../utils/services/templatesAPI';
import { getMailTemplateDetails } from '../../utils/services/mailTemplateAPI';

// app store context API
import { dayConversion, monthConversion } from '../../utils/javascript';
import { AppStoreContext } from '../../context/appStoreContext';
import { correctBaseUrl } from '../../utils/svgUtils';
import { DOCUMENT_TEMPLATES_LIST } from './translationValues';
import { useTranslation } from 'react-i18next';

const NAMESPACES = ['DOCUMENT_TEMPLATES_LIST'];

const MasterTempSection = props => {
  const { tempCategories, isMailTemplates } = props;
  const { t } = useTranslation(NAMESPACES);
  const history = useHistory();
  const [cloneTemplate, setCloneTemplate] = useState(undefined);
  const {
    templatesList,
    totalTemplates,
    fetchingCategories,
  } = useContext(AppStoreContext);

  const redirectToTemplate = template => {
    setCloneTemplate(undefined);
    if (template.id) {
      if (isMailTemplates) {
        history.push(`/emailDesign/${template.id}`);
      } else {
        history.push(`/design/${template.id}`);
      }
    }
  };

  const handleMasterTemplates = async templateObj => {
    if (isMailTemplates) {
      let masterTemplateResp = await getMailTemplateDetails(templateObj.mailTemplateId);
      masterTemplateResp.data && setCloneTemplate(masterTemplateResp.data);
    } else {
      let masterTemplateResp = await getTemplate(templateObj.id);
      masterTemplateResp.data?.pages.length && setCloneTemplate(masterTemplateResp.data);
    }
  };

  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        {templatesList.length > 0 && (
          <>
            <TemplateWrapper>
              {templatesList.map(templateObj => {
                const thumbnailKey = isMailTemplates ? 'thumbNailUrl' : 'thumbnail';
                return (
                  <div key={templateObj.id}>
                    <div className="test">
                      <TemplatePageOverview
                        key={templateObj.id}
                        title={templateObj.name}
                        onClick={() => handleMasterTemplates(templateObj)}
                      >
                        <TemplateImage>
                          <div className="image-wrapper">
                            <div key={templateObj.categoryId} className="preview-image-div">
                              <img
                                src={
                                  templateObj[thumbnailKey]
                                    ? correctBaseUrl(templateObj[thumbnailKey])
                                    : PageNotFoundIllustration
                                }
                                alt="pageObj-thumbnail"
                                className={!templateObj.thumbnail ? 'no-thumbnail' : ''}
                              />
                            </div>
                          </div>
                        </TemplateImage>
                        <div className="template_name">
                          <div className="name" onClick={() => handleMasterTemplates(templateObj)}>
                            {templateObj.name}{' '}
                          </div>
                          <div className="categoryName">
                            <div className="box2"></div>
                            {categoriesTemp.length > 0 &&
                              categoriesTemp.map(category => (
                                <div key={category.categoryId}>
                                  {templateObj.categoryId === category.categoryId &&
                                    category.categoryName}
                                </div>
                              ))}
                          </div>

                          {(templateObj.updatedOn || templateObj.createdOn) && (
                            <div className="template_date">
                              <p>
                                {templateObj.updatedOn
                                  ? dayConversion(templateObj.updatedOn)
                                  : dayConversion(templateObj.createdOn)}
                              </p>
                              <p className="month">
                                {templateObj.updatedOn
                                  ? monthConversion(templateObj.updatedOn)
                                  : monthConversion(templateObj.createdOn)}
                              </p>
                            </div>
                          )}
                        </div>
                      </TemplatePageOverview>
                    </div>
                  </div>
                );
              })}
            </TemplateWrapper>
          </>
        )}
      </React.Fragment>
    );
  };
  return (
    <Container>
      {fetchingCategories ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <TemplateConatiner>
          <>{totalTemplates === 0 ? '' : renderBody(tempCategories, templatesList)}</>
          {templatesList.length > 0 && (
            <>
              {templatesList.length !== totalTemplates && templatesList.length >= 8 && (
                <div className="addMore">
                  <Icon type="loading" />
                  {t(
                    DOCUMENT_TEMPLATES_LIST.LOADING_MORE.key,
                    DOCUMENT_TEMPLATES_LIST.LOADING_MORE.value,
                  )}
                </div>
              )}
              {templatesList.length === totalTemplates && templatesList.length !== 0 && (
                <div className="allData">
                  {' '}
                  {t(
                    DOCUMENT_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.key,
                    DOCUMENT_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.value,
                  )}
                </div>
              )}
            </>
          )}

          {cloneTemplate &&
            (isMailTemplates ? (
              <CreateMailTemplateModal
                visible={true}
                onCancel={() => setCloneTemplate(false)}
                onSucess={redirectToTemplate}
                type="cloneTemplate"
                template={cloneTemplate}
              />
            ) : (
              <CreateTemplateModal
                visible={true}
                onCancel={() => setCloneTemplate(false)}
                onSucess={redirectToTemplate}
                categoryType="template"
                type="cloneTemplate"
                template={cloneTemplate}
              />
            ))}
        </TemplateConatiner>
      )}
      {!fetchingCategories && templatesList.length === 0 && (
        <EmptySettingsDetails>
          <div className="empty-illustration">
            <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
          </div>
          <div className="empty-txt" style={{ color: 'black' }}>
            <span>
              {t(
                DOCUMENT_TEMPLATES_LIST.LOADING_MORE.key,
                DOCUMENT_TEMPLATES_LIST.LOADING_MORE.value,
              )}
            </span>
          </div>
        </EmptySettingsDetails>
      )}
    </Container>
  );
};

export default MasterTempSection;
